import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { Availability, ProductListing } from '../../types/product.type';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { Observable, of } from 'rxjs';
import { buildUrl } from '../../../../urls';
import { AuthService } from '../../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    listings = [];

    private apiEndpoint = buildUrl(this.appSettings.realtimeEndpointUrl, `/api/retailer`);

    constructor(
        private httpClient: HttpClient,
        private appSettings: AppSettings,
        private authService: AuthService
    ) {
    }

    /**
     * @description Get listings data
     * @returns Returns an array of hard-coded products from the local json file
     */
    public getListingsWithToken(token: string): Observable<ProductListing[]> {
        let activeProducts;

        return this.httpClient.get(this.apiEndpoint + `/${this.appSettings.retailerId}/models`, { headers: { 'Authorization': `Bearer ${token}` } }).pipe(
            map(data => this.skipProducts(data)),
            map((res: any) => {
                res.map((item: ProductListing) => {
                      item.image = `${item.image}?w=600&h=375&fit=fill`;
                    item.items.map((product) => {

                        if (product.fuelOptions != null) {
                            product.isElectric = product.fuelOptions.includes("Electric");
                            product.isHybrid = product.fuelOptions.includes("Plug-in Hybrid");
                        }
                        product.imageUrl = `${product.image}?w=310&h=186&fit=fill`;
                        product.series = item.name;
                    });
                });

                this.listings = res;
                return this.listings;
            })
        );
    }


    public getListings(): Observable<ProductListing[]> {
        let activeProducts;

        return this.authService.getToken().pipe(switchMap((token) => {
            return this.getListingsWithToken(token);
        }));
    }


    // Attempt to loop through products (vehicles) that should be skipped and
    // find them in the list of product. If found, then remove from the list.
    private skipProducts(products: any) {
        // Loop through each string. Each string represents the product category.
        environment.productsToBeSkipped.forEach(vehicleName => {
            // Get the index of the item.
            const index = products.findIndex(product => product.category === vehicleName);

            // If index is -1, then no products were found. If this is the case, then
            // dont proceed.
            if (index === -1) {
                return;
            }
            products.splice(index, 1);
        });

        return products;
    }
}
